
export function getJointName(model, jointIndex) {
	let textDecoder = new TextDecoder('utf-8');
	let names_array = new Uint8Array(model.names);

	let start_idx = model.name_jntadr[jointIndex];
	let end_idx = start_idx;
	while (end_idx < names_array.length && names_array[end_idx] !== 0) {
		end_idx++;
	}
	let name_buffer = names_array.subarray(start_idx, end_idx);
	return textDecoder.decode(name_buffer);
}

export function getActuatorName(model, actuatorIndex) {
	let textDecoder = new TextDecoder('utf-8');
	let names_array = new Uint8Array(model.names);

	let start_idx = model.name_actuatoradr[actuatorIndex];
	let end_idx = start_idx;
	while (end_idx < names_array.length && names_array[end_idx] !== 0) {
		end_idx++;
	}
	let name_buffer = names_array.subarray(start_idx, end_idx);
	return textDecoder.decode(name_buffer);
}

/**
 * Pack relevant MuJoCo model information (for Python SEWMimicG1 initialization)
 * @param {*} model MuJoCo model object
 * @returns {Object} Packed model data for Python
 */
export function packMujocoModel(model) {
	if (!model) {
		throw new Error('Model is null or undefined');
	}

	// Extract joint names
	const jointNames = [];
	for (let i = 0; i < model.njnt; i++) {
		jointNames.push(getJointName(model, i));
	}

	// Extract actuator names
	const actuatorNames = [];
	for (let i = 0; i < model.nu; i++) {
		actuatorNames.push(getActuatorName(model, i));
	}

	return {
		// Joint information
		joints: {
			names: jointNames,
			qposadr: Array.from(model.jnt_qposadr),
			dofadr: Array.from(model.jnt_dofadr)
		},
		// Actuator information
		actuators: {
			names: actuatorNames
		},
		// Model metadata
		metadata: {
			njnt: model.njnt,
			nu: model.nu,
			nq: model.nq,
			nbody: model.nbody
		}
	};
}

/** Standard normal random number generator using Box-Muller transform */
export function standardNormal() {
	return Math.sqrt(-2.0 * Math.log(Math.random())) * Math.cos(2.0 * Math.PI * Math.random());
}
